
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Component, Vue } from 'vue-property-decorator';
import { Editor } from '@toast-ui/vue-editor';

@Component({
  inheritAttrs: false,
  components: {
    Editor,
  },
})
export default class SchemeEditor extends Vue {
  get editorOptions() {
    return {
      hideModeSwitch: true,
      toolbarItems: ['heading', 'bold', 'italic', 'divider', 'ul', 'ol', 'indent', 'outdent', 'divider'],
    };
  }
}
